import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {User} from "../../../objects/user";
import {SharedDataService} from "../../../services/shared-data.service";
import {environment} from "../../../../environments/environment";
import {FormControl, FormGroup} from "@angular/forms";
import {FS3Notification} from "../../../objects/notification";

/**Widget trainer popup. todo...*/

@Component({
  selector: 'app-trainer-info-popup',
  templateUrl: './trainer-info-popup.component.html',
  styleUrls: ['../../dialog-canvas/dialog-canvas.component.scss']
})
export class TrainerInfoPopupComponent implements OnInit {
  @Input() application: AppComponent;
  @Input() profile: User;
  @Output() close = new EventEmitter<void>();

  constructor(public sharedDataService: SharedDataService) { }

  public componentForm: FormGroup = new FormGroup({
    pickedTrainerService: new FormControl('')
  });
  state = 'default';
  profilePayloadParsed:object;
  trainerDescription:string;
  profileServices: object[];
  servicePicked: string;
  ngOnInit(): void {
    const package_type = environment['default_trainer_package']; // may be replaced if there will be various trainer's serrvices, e.g.: squash services, gym services, etc
    this.profilePayloadParsed = JSON.parse(this.profile.payload);
    this.profilePayloadParsed = this.profilePayloadParsed ? this.profilePayloadParsed : {};
    if(!this.profilePayloadParsed['services']) this.profilePayloadParsed['services'] = {};
    this.trainerDescription = this.profilePayloadParsed['trainer_description'] ? this.profilePayloadParsed['trainer_description'].replace(/\n+/g,'<br>') : '';
    window['trainerDescription'] = this.trainerDescription;
    this.profileServices = this.profilePayloadParsed['services'][package_type];
    console.log(this.profilePayloadParsed)

    if(this.profileServices?.length) {
      this.loadServicesDetails(package_type);
    }
  }

  public loadServicesDetails(package_type): void {
    this.state = 'loading';
    this.application.apiService.getPackageDetails(environment['gid'],environment['g_hash'],true)
      .subscribe (
        data => {
          //todo - rewrite below
          const packageServices = JSON.parse(data['package_services']);
          packageServices.forEach(packageService => {
            this.profileServices.forEach(profileService => {
              if(profileService['service_key'] != packageService['service_key']) return;
              profileService['service_name'] = packageService['name'];
              profileService['currency'] = packageService['currency'];
            })
          })

          this.state = 'default';
        },
        error => {
          this.state = 'error';
          const { exception } = error;
          if (exception && exception.error && exception.error.message) {
            let notification = new FS3Notification();
            notification.type = 'error';
            notification.text = exception.error.message;
            this.sharedDataService.pushNotification(notification);
          }
        }
      )
  }

  public servicePick(service_key): void {
    this.servicePicked = service_key;
  }

  public onNoClick(): void {
    //this.dialogRef.close();
    this.close.emit()
  }

  public orderClick(): void {
    if(environment['mobile_exit_strategy'] === 'viber') {
      // let exit_context = '__todo';
      // window.open(environment['viber_url']+exit_context)
    }
  }
}
